<template>
  <div class="userBox">
    <div class="user boxShadow">
      <div class="images">
        <img :src="userInfo.avatar?userInfo.avatar:require('../../public/images/user.jpg')" alt="">
      </div>
      <p>{{userInfo.nickname}}</p>
    </div>
    <ul class="menu boxShadow">
      <li :class="currentType==1?'active':''" @click="jump(1)">我的预约</li>
      <li :class="currentType==7?'active':''" @click="jump(5)">非遗预约</li>
      <li :class="currentType==2?'active':''" @click="jump(2)">课程报名</li>
      <li :class="currentType==6?'active':''" @click="jump(6)">活动报名</li>
      <li :class="currentType==3?'active':''" @click="jump(3)">意见反馈</li>
      <li :class="currentType==4?'active':''" @click="jump(4)">账号设置</li>
      <li :class="currentType==5?'active':''" @click="logout">退出登录</li>
    </ul>
  </div>
</template>

<script>
export default {
  inject: ['ajax'],
  props: ['headImg', 'currentType', 'nickname', 'showFlag'],
  data() {
    return {
      userInfo: {},
      flag: true,
      screenwidth: window.screen.width
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {
    if (window.screen.width > 750) {
      this.flag = true
    } else {
      this.flag = this.showFlag
    }
    this.ajax('/api/user/info', 'get', '', res => {
      this.userInfo = res.data.data
    })
  },
  watch: {
    screenwidth() {
      if (window.screen.width > 750) {
        this.flag = true
      } else {
        this.flag = val
      }
    },
    showFlag(val) {
      if (window.screen.width > 750) {
        this.flag = true
      } else {
        this.flag = val
      }
    }
  },
  methods: {
    // 退出登录
    logout() {
      this.ajax('/api/login/logout', 'get', {}, res => {
        this.$router.push('/login')
      })
    },
    jump(type) {
      this.$nextTick(() => {
        if (type == this.currentType) {
          return
        } else {
          let url = ''
          switch (type) {
            case 1:
              url = "/myorder"
              break;
            case 2:
              url = "/myCourse"
              break;
            case 3:
              url = "/opinion"
              break;
            case 4:
              url = "/account"
              break;
            case 6:
              url = "/myActivity"
              break;
            case 5:
              url = '/myorder_feiyi'
              break;
            default:
              break;
          }
          this.$router.replace(url)
        }
      })


    }
  },
  components: {

  },
};
</script>

<style scoped>
.user {
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0 30px;
}

.user .images {
  overflow: hidden;
  width: 6em;
  height: 6em;
  border-radius: 50%;
  margin-bottom: 10px;
}

.user .images img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user p {
  font-size: 1em;
  color: #333333;
  font-weight: bold;
  line-height: 1.8;
}

.menu {
  width: 100%;
  background: #fff;
  margin-top: 15px;
}

.menu li {
  line-height: 60px;
  font-size: 1em;
  text-align: center;
  color: #333;
  position: relative;
  cursor: default;
}

.menu li.active {
  background: #4ba6ff;
  color: #fff;
}

.menu li.active::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  background: url(../assets/arrow.png);
  background-size: 100% 100%;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.menu li:hover {
  background: #4ba6ff;
  color: #fff;
}

@media only screen and (max-width: 750px) {
  .userBox {
    width: calc(100vw * 0.5);
    z-index: 999999;
    position: fixed;
    background: #fff;
    width: 100%;
  }

  .menu {
    margin-top: 0;
    display: flex;
  }

  .user {
    display: none;
  }

  .menu li {
    line-height: 0.4rem;
    font-size: 0.14rem;
    flex: 1;
  }

  .menu li.active::after {
    display: none;
  }
  .menu li:last-child {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #4ba6ff;
    color: #fff;
  }
}
</style>